import Tooltip from '@material-ui/core/Tooltip';
import { HelpOutline } from '@material-ui/icons';
import React, { cloneElement } from 'react';
import RenderBreakpoint from '../breakpoints/RenderBreakpoint';
import { createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = createStyles((theme) => ({
  tooltipIcon: {
    position: 'absolute',
    fontSize: 20,
    right: 12,
    top: -10,
  },
}));

const FieldWithTooltip = ({ formField, helperText, classes }) => {
  
  return (
    <RenderBreakpoint mobile desktop>
      {({ isMobile, isDesktop }) => (
        <React.Fragment>
          {(isDesktop) &&
          (<div style={{ position: 'relative' }}>
            {formField}
            {helperText &&
            <Tooltip className={`${classes.tooltipIcon} tooltipIcon`} title={helperText}>
              <HelpOutline color="secondary" />
            </Tooltip>}
          </div>)}
          
          {(isMobile) && (cloneElement(formField, { helperText: helperText }))}
        </React.Fragment>
      )}
    </RenderBreakpoint>
  );
};

export default withStyles(styles)(FieldWithTooltip);